import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthorizeBeforeRedirectModule } from '@app/shared/directives/authorize-before-redirect.module';
import { WucLinkModule, WucListModule } from '@inshared/website-ui-components';
import { SidemenuComponent } from './sidemenu.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        AuthorizeBeforeRedirectModule,
        WucListModule,
        WucLinkModule,
    ],
    exports: [
        SidemenuComponent,
    ],
    declarations: [
        SidemenuComponent,
    ],
})
export class SidemenuModule {}
